var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c31.314 0 61.311-5.632 89.043-15.923l11.131-240.077-11.13-240.077c-27.733-10.29-57.73-15.923-89.044-15.923s-61.311 5.633-89.043 15.923l-11.131 240.077 11.13 240.077c27.733 10.291 57.73 15.923 89.044 15.923z",
    fill: "#0052b4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a2001d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 110.071 69.472 203.906 166.957 240.077v-480.154c-97.485 36.171-166.957 130.006-166.957 240.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.043 15.923v480.155c97.485-36.172 166.957-130.007 166.957-240.078s-69.472-203.906-166.957-240.077z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.435 256h22.261v89.043h-22.261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.391 256h22.261v89.043h-22.261z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.043,
    cy: 289.391,
    r: 22.261
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.043,
    cy: 211.478,
    r: 11.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.783 322.783h44.522v22.261h-44.522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.783 233.739h44.522v22.261h-44.522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.043 133.565 7.884 24.26h25.508l-20.635 14.994 7.878 24.26-20.635-14.994-20.634 14.994 7.878-24.26-20.635-14.994h25.508z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongolia);
export default __webpack_public_path__ + "static/media/mongolia.9ec8367845087800d117ac3c6484b13f.svg";
export { ForwardRef as ReactComponent };